<template>
  <el-dialog
    append-to-body
    width="600px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">变更记录</div>
    </template>
    <div style="max-height: 500px; overflow: auto">
      <div v-for="(item, index) in list" :key="index" class="record-item">
        <div style="margin-bottom: 10px">更新时间：{{ item.update_time }}</div>
        <el-descriptions
          :labelStyle="label_style"
          :contentStyle="content_style"
          :column="1"
          size="mini"
          border
          style="margin-bottom: 10px"
        >
          <el-descriptions-item
            v-for="(i, k) in getItemList(item)"
            :key="k"
            :label="getLabel(i)"
          >
            <span v-if="i == 'financing_type'"
              >改 {{ fiTypeMap[item[i].toString()] }}</span
            >
            <span v-else-if="i == 'nature'"
              >改 {{ natureMap[item[i].toString()] }}</span
            >
            <template v-else-if="i == 'business'">
              <span>改</span>
              <el-image
                :src="item[i]"
                style="width: 60px; height: 60px"
                :preview-src-list="[item[i]]"
              ></el-image>
            </template>
            <span v-else-if="i == 'register_money'"> 改 {{ item[i] }}万 </span>
            <span v-else>改 {{ item[i] }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <template #footer> </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      btnLoading: false,
      visible: false,
      list: [],
      label_style: {
        width: "30%",
      },
      content_style: {
        width: "70%",
      },
      // 1-未融资；2-种子轮；3-天使轮；4-A轮；5-B轮；6-C轮及以后；7-Pre-IPO轮；8-已上市；9-不需要融资；
      fiTypeMap: {
        1: "未融资",
        2: "种子轮",
        3: "天使轮",
        4: "A轮",
        5: "B轮",
        6: "C轮及以后",
        7: "Pre-IPO轮",
        8: "已上市",
        9: "不需要融资",
      },
      // //企业类型 1:国有企业 2:民营企业 3:股份制企业 4:外资企业 5:合伙企业 6:事业单位 7:行政机关
      natureMap: {
        1: "国有企业",
        2: "民营企业",
        3: "股份制企业",
        4: "外资企业",
        5: "合伙企业",
        6: "事业单位",
        7: "行政机关",
      },
      labelMap: {
        company_name: "企业名称",
        before_company_name: "变更前",
        xy_code: "信用代码",
        before_xy_code: "变更前",
        nature: "企业类型",
        before_nature: "变更前",
        legal: "法人",
        before_legal: "变更前",
        legal_id_card: "法人身份证号码",
        before_legal_id_card: "变更前",
        register_money: "注册资金",
        before_register_money: "变更前",
        register_date: "注册时间",
        before_register_date: "变更前",
        financing_type: "融资情况",
        before_financing_type: "变更前",
        business: "营业执照",
        before_business: "变更前",
      },
    };
  },
  methods: {
    toggle(val) {
      this.visible = val;
    },
    getDetail(row) {
      this.info = row;
      this.init();
    },
    getItemList(item) {
      let list = Object.keys(item).filter((i) => i != "update_time");
      return list;
    },
    getLabel(i) {
      return this.labelMap[i];
    },
    init() {
      let _params = {
        id: this.info.id,
      };
      this.$http
        .get("/admin/company/submitList", { params: _params })
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data.list;
            // let compareList = [
            //   "company_name",
            //   "before_company_name",
            //   "xy_code",
            //   "before_xy_code",
            //   "nature",
            //   "before_nature",
            //   "legal",
            //   "before_legal",
            //   "legal_id_card",
            //   "before_legal_id_card",
            //   "register_money",
            //   "before_register_money",
            //   "register_date",
            //   "before_register_date",
            //   "financing_type",
            //   "before_financing_type",
            //   "license",
            //   "before_license",
            // ];
            let compareList = [
              "company_name",
              "xy_code",
              "nature",
              "legal",
              "legal_id_card",
              "register_money",
              "register_date",
              "financing_type",
              "business",
            ];
            this.list = this.list.map((item) => {
              // 只保留 compareList 里面存在的key
              const newObj = {};
              for (const key of compareList) {
                if (
                  item.hasOwnProperty(key) &&
                  item[key] !== item[`before_${key}`]
                ) {
                  newObj[key] = item[key];
                  // newObj[`before_${key}`] = item[`before_${key}`];
                }
              }
              return {
                ...newObj,
                update_time: item.update_time,
              };
            });
            console.log(this.list, "this.list");
          }
        });
    },
    reset() {
      this.visible = false;
      this.info = {};
      this.list = [];
    },
  },
};
</script>